import React, { useEffect, useState } from 'react';
import Header from '../../components/common/global-top-bar';
import SwitchBar from '../../components/switch-bar';
import { HeaderOptions } from '../clients/clients-constants';
import HeadBack from '../clients/redirect';
import CalendarPaginator from '../../components/calender-paginator';
import { NumericLabel } from '../../components/common';
import { StackedBarChart } from '../../components/charts';
import { VerticalBarChart } from '../../components/charts';
import Spinner from '../../components/common/spinner';
import { useClient } from '../../hooks/useClients';
import { useClientReportingOverview } from '../../hooks/useReporting';

const options = {
  title: '',
  chartArea: { width: '35%', height: '90%' },
  colors: ['#1D1183'],
  legend: { position: 'none' },
  hAxis: {
    title: '',
    minValue: 0,
  },
  vAxis: {
    title: '',
  },
};

const Reporting: React.FunctionComponent = (): JSX.Element => {
  const clientId = localStorage.getItem('clientid');
  const { data: client, isLoading: clientLoading } = useClient(Number(clientId!));
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const { data: clientReporting, isLoading: clientReportingLoading } = useClientReportingOverview(
    Number(clientId!),
    startDate,
    endDate,
  );

  const members = clientReporting?.members || null;
  const checkins = clientReporting?.check_ins || null;
  const stroyListens = clientReporting?.story_listens || null;
  const calls = clientReporting?.calls || null;
  const engagementByTag = clientReporting?.engagement_by_tag || null;
  const engagementByTopic = clientReporting?.engagement_by_topic || null;
  const crisisElevations = clientReporting?.crisis_elevations || null;
  const TopicChart =
    engagementByTopic && engagementByTopic?.length > 0
      ? engagementByTopic.map((item: any) => [item.label, item.value, '', item.value])
      : [];
  const TagChart =
    engagementByTag && engagementByTag?.length > 0
      ? engagementByTag.map((item: any) => [item.label, item.value, '', item.value])
      : [];
  const TopicChartData = [['Topic', 'Topics of intrests', { role: 'style' }, { role: 'annotation' }], ...TopicChart];
  const TagChartData = [['Tags', 'Tags of intrests', { role: 'style' }, { role: 'annotation' }], ...TagChart];

  // setTopicschartData(TopicChartData1);

  const changedDate = (startDate: string, endDate: string) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const calculateMemeberPercenetage = (data: number) => {
    if (members?.total && members?.total > 0) return Math.floor((data / members?.total) * 100).toString() + ' % ';
    else return '0 %';
  };
  return (
    <div>
      {clientLoading || (clientReportingLoading && <Spinner />)}
      <Header heading={<HeadBack clientName={client?.name || ''} />} />
      <SwitchBar heading={HeaderOptions} position={0} isDisabled={clientId ? false : true} />
      <CalendarPaginator changedDate={changedDate} />
      <div className="max-window-height-group overflow-y-auto px-7">
        <div className="w-full">
          <div className="flex justify-between py-4">
            <div className="text-gray-dark font-base border-gray-dark w-1/4 border-b font-bold">
              Total Eligible Members
            </div>
            <div className="text-gray-dark font-base border-gray-dark w-1/4 border-b font-bold">Activated Members</div>
            <div className="text-gray-dark font-base border-gray-dark w-1/4 border-b font-bold">Engaged Members</div>
            <div className="text-gray-dark font-base border-gray-dark w-1/4 border-b font-bold">Connected Members</div>
          </div>
          <div className="flex justify-between">
            <div className="w-1/4">
              <NumericLabel
                numericValue={members?.total && members?.total > 0 ? members?.total.toString() : '0'}
                label={''}
              />
            </div>
            <div className="w-1/4">
              <NumericLabel
                numericValue={members?.active && members?.active > 0 ? members?.active.toString() : '0'}
                label={calculateMemeberPercenetage(members?.active || 0) || '0'}
              />
            </div>
            <div className="w-1/4">
              <NumericLabel
                numericValue={members?.engaged && members?.engaged > 0 ? members?.engaged.toString() : '0'}
                label={calculateMemeberPercenetage(members?.engaged || 0) || '0'}
              />
            </div>
            <div className="w-1/4">
              <NumericLabel
                numericValue={members?.connected && members?.connected > 0 ? members?.connected.toString() : '0'}
                label={calculateMemeberPercenetage(members?.connected || 0) || '0'}
              />
            </div>
          </div>
        </div>

        <div className="flex justify-between">
          <div className="w-full flex-col">
            <div className="gray-border-line text-gray-dark relative w-full border-b py-3 text-base font-bold">
              {' '}
              Crisis Elevations
            </div>

            <div className="flex w-3/4 justify-between">
              {/* <Histogram error={false} data={data} options={options} /> */}
              <div className="text-red py-3 text-4xl">{crisisElevations?.total_crisis_elevations || 0}</div>
              <div className="flex-col">
                <div className="text-red py-3 text-4xl">{crisisElevations?.percentage_elevated_members || 0} %</div>
                <p className="text-gray-dark">of Members</p>
              </div>
            </div>
            <div className="gray-border-line text-gray-dark relative w-full border-b py-3 text-base font-bold">
              Check-ins
            </div>
            <div className="flex w-3/4 justify-between">
              {/* <Histogram error={false} data={data} options={options} /> */}
              <div className="blue-primary py-3 text-4xl">{checkins?.total_responses || 0}</div>
              <div className="flex-col">
                <div className="blue-primary py-3 text-4xl">{checkins?.response_percentage || 0} %</div>
                <span>{checkins?.total_sent || 0} Sent</span>
              </div>
            </div>
            <div className="text-gray-dark relative w-full border-b py-3 text-base font-bold">Mood Distribution</div>
            <MoodDistributions data={checkins?.mood_distribution || {}} />
            <div className="gray-border-line text-gray-dark relative w-full border-b py-3 text-base font-bold">
              Story Listens
            </div>
            <div className="flex w-3/4 justify-between">
              {/* <Histogram error={false} data={data} options={options} /> */}
              <div className="blue-primary py-3 text-4xl">{stroyListens?.total_listens || 0}</div>
              <div className="flex-col">
                <div className="blue-primary py-3 text-4xl">{stroyListens?.member_percentage || 0} %</div>
                <span>Of Members</span>
              </div>
            </div>
            <div className="gray-border-line text-gray-dark relative w-full border-b py-3 text-base font-bold">
              Calls
            </div>
            <div className="flex w-3/4 justify-between">
              <div className="blue-primary py-3 text-4xl">{calls?.total || 0}</div>
              <div className="flex-col">
                <div className="blue-primary py-3 text-4xl">{calls?.member_percentage} %</div>
                <span>Of Members</span>
              </div>
            </div>
            <div className="gray-border-line text-gray-dark relative flex w-full border-b py-3 text-base font-bold">
              Engagement by Tag
            </div>
            <div className="w-3/4">
              {/* <WeeklyChart error={false} /> */}
              {TagChartData?.length > 1 ? (
                <VerticalBarChart data={TagChartData} options={options} key={Math.random()} />
              ) : (
                'No Data Available'
              )}
            </div>
          </div>
          <div className="w-full px-7">
            <div className="gray-border-line text-gray-dark relative flex w-full border-b py-3 text-base font-bold">
              Topics of Interests
            </div>
            <div className="w-full">
              {/* <WeeklyChart error={false} /> */}
              {TopicChartData?.length > 1 ? (
                <VerticalBarChart data={TopicChartData} options={options} key={Math.random()} />
              ) : (
                'No Data Available'
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

type moodChartprops = {
  data: any;
};
const MoodDistributions: React.FC<moodChartprops> = ({ data }): JSX.Element => {
  const { positive, neutral, negative } = data;
  const [Nodata, setNodata] = useState(false);

  const arrayData = [
    {
      bgColor: 'stacked-bar-red-primary',
      width: negative?.response_percentage,
    },
    {
      bgColor: 'stacked-bar-orange-primary',
      width: neutral?.response_percentage,
    },
    {
      bgColor: 'stacked-bar-green-primary',
      width: positive?.response_percentage,
    },
  ];

  useEffect(() => {
    if (
      parseInt(positive?.response_percentage) === 0 &&
      parseInt(neutral?.response_percentage) === 0 &&
      parseInt(negative?.response_percentage) === 0
    ) {
      setNodata(true);
    } else {
      setNodata(false);
    }
  }, [data]); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="w-full py-3">
      <div className="flex h-2/3 w-full items-end justify-between">
        {!Nodata ? (
          arrayData.map((item) => <StackedBarChart xwidth={`${item.width}%`} backGroundColor={item.bgColor} />)
        ) : (
          <div className="text-monsterrat bg-gray-light flex h-10 w-full items-center justify-center border border-white text-center font-bold text-white">
            No check-in responses
          </div>
        )}
      </div>
      <div className="text-gray-dark flex items-center py-1 text-sm">Negative / Neutral / Positive</div>
    </div>
  );
};

export default Reporting;
